export const CompanyOrderModel = [
  {
    key: "carDetails",
    dataType: Object,
  },
  {
    key: "comments",
    dataType: String,
  },
  {
    key: "carImages",
    dataType: Array,
  },
  {
    key: "orderData",
    dataType: Array,
  },
  {
    key: "type",
    dataType: Array,
  },
  {
    key: "ownerId",
    dataType: Array,
  },
  {
    key: "uid",
    dataType: String,
  },
  {
    key: "status",
    dataType: String,
  },
  {
    key: "actionDate",
    dataType: String,
  },
];
